import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload" }

import { ref, watch } from "vue";

import type { UploadFile } from "element-plus/es/components/upload/src/upload.type";
interface RawFile {
  name: string;
  url: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  files: [],
  multiple: () =>true,
},
  emits: ["onSuccess"],
  setup(__props, { emit: __emit }) {

const baseURL = process.env.VUE_APP_BASE_API;
const header = { "user-token": sessionStorage.getItem("token") };
const props = __props;
let fileList = ref<RawFile[]>([]);

const emit = __emit;
 
if(props.files){
  for (const item of props.files) {
    fileList.value.push({ name: item.fileRealName, url: item.fileName });
  }
} 

watch(
  () => props.files,
  (newv, oldv) => {
    console.log(props.files);
    
    fileList.value= [];
    for (const item of props.files) {
     fileList.value.push({ name: item.fileRealName, url: item.fileName });
    }
  }
);
const list = ref([]);

const handleSuccess = (file: UploadFile) => {
  console.log(file);
  
  list.value.push(file.data);
  emit("onSuccess", list);
};

const handleRemove = (file: UploadFile, fileList: UploadFile[]) => {
  for (let i = 0; i < list.value.length; i++) {
    if (list.value[i].fileRealName === file.name) {
      list.value.splice(i, 1);
    }
  }
  emit("onSuccess", list);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      class: "upload-demo",
      action: _unref(baseURL) + 'sys/upload/other',
      "on-success": handleSuccess,
      "on-remove": handleRemove,
      headers: header,
      multiple: __props.multiple,
      limit: __props.multiple?5:1,
      "file-list": _unref(fileList)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, { type: "primary" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("上传附件", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["action", "multiple", "limit", "file-list"])
  ]))
}
}

})